// extracted by mini-css-extract-plugin
module.exports = {"mailing_list__container":"styles_mailing_list__container__q1Ash","title":"styles_title__LNKXY","body":"styles_body__H5Xs_"};